import styled from "styled-components";
import { units } from "@m/alchemy-theme";
export const ActivityFeed = styled.ol `
  margin-top: ${units(1)};
`;
